export const matomoPush = (args) => {
  if (typeof window === 'undefined') return;

  window._paq = window._paq || [];
  window._paq.push(args);
};

export const trackEvent = (category, action, name, value) => {
  matomoPush(['trackEvent', category, action, name, value].filter((arg) => arg !== undefined));
};
